import { SalesReportCreditDebitNote } from "../../../types/sale-reports.type";
import {
  CREDIT_NOTE_LABEL,
  DEBIT_NOTE_LABEL,
  NET_LABEL,
  hasNotes,
  noteCountLabel,
} from "../../CreditDebitNote/reportFigures";
import SummaryBox from "./SummaryBox";

const BAHT_UNIT = "บาท";
const NET_SALES_LABEL = `ยอดขาย${NET_LABEL}`;

interface NoteSummaryBoxesProps {
  /** Null for a report with no business day; absent on a backend that predates the notes. */
  notes: SalesReportCreditDebitNote | null | undefined;
}

/**
 * The route-day's ใบลดหนี้ / ใบเพิ่มหนี้ beside the report's own figures, with the sales they
 * leave (ex-VAT, like ยอดก่อนภาษีมูลค่าเพิ่ม). A day with no note draws nothing, so its report
 * reads as it always did.
 */
export default function NoteSummaryBoxes({ notes }: Readonly<NoteSummaryBoxesProps>) {
  if (!notes || !hasNotes(notes)) return null;

  return (
    <>
      <SummaryBox
        title={`${CREDIT_NOTE_LABEL} (${noteCountLabel(notes.credit_note_count)})`}
        total={notes.credit_note_amount}
        unit={BAHT_UNIT}
        tone="error"
      />
      <SummaryBox
        title={`${DEBIT_NOTE_LABEL} (${noteCountLabel(notes.debit_note_count)})`}
        total={notes.debit_note_amount}
        unit={BAHT_UNIT}
      />
      <SummaryBox title={NET_SALES_LABEL} total={notes.net_sales} unit={BAHT_UNIT} />
    </>
  );
}
